import * as React from "react";
const SvgGlobe = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 8H14.5M2.5 8C2.5 11.3137 5.18629 14 8.5 14M2.5 8C2.5 4.68629 5.18629 2 8.5 2M14.5 8C14.5 11.3137 11.8137 14 8.5 14M14.5 8C14.5 4.68629 11.8137 2 8.5 2M8.5 14C3.67041 8.72 6.48767 3.8 8.5 2M8.5 14C13.3296 8.72 10.5123 3.8 8.5 2",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgGlobe;
